import { render, staticRenderFns } from "./NphFamilyHistory.vue?vue&type=template&id=53bf7a5d"
import script from "./NphFamilyHistory.vue?vue&type=script&lang=js"
export * from "./NphFamilyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports